import { isEmpty } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';

const mapAwardsContent = ({ cmsSectionContent }: any) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  // TODO: check format of data from cmsSectionContent once Award is on the Explained Term model
  const mappedCmsContent = {
    imageObject: cmsSectionContent.imageObject,
    name: cmsSectionContent.name,
    orderIndex: cmsSectionContent.orderIndex,
    summaryRaw: cmsSectionContent.summary,
    type: CONTENT_SECTIONS.AWARD,
  };

  return mappedCmsContent;
};

export default mapAwardsContent;
